"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSapphireOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockSapphireOracleFactory = /** @class */ (function (_super) {
    __extends(MockSapphireOracleFactory, _super);
    function MockSapphireOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockSapphireOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockSapphireOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockSapphireOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockSapphireOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockSapphireOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockSapphireOracleFactory;
}(contracts_1.ContractFactory));
exports.MockSapphireOracleFactory = MockSapphireOracleFactory;
var _abi = [
    {
        inputs: [],
        name: "currentPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "reportRealTimestamp",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_price",
                type: "uint256",
            },
        ],
        name: "setPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_reportRealTimestamp",
                type: "bool",
            },
        ],
        name: "setReportRealTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "setTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x6080604052678ac7230489e8000060009081556001556002805460ff1916905534801561002b57600080fd5b506101bf8061003b6000396000f3fe608060405234801561001057600080fd5b506004361061007d5760003560e01c806396a0e5e31161005b57806396a0e5e3146100d45780639d1b464a146100f1578063a0a2b573146100fa578063de7ff6271461010d57600080fd5b80632f350b891461008257806340792ebb146100a557806391b7f5ed146100c1575b600080fd5b6100a361009036600461014a565b6002805460ff1916911515919091179055565b005b6100ae60015481565b6040519081526020015b60405180910390f35b6100a36100cf366004610171565b600055565b6100dc61012a565b604080519283526020830191909152016100b8565b6100ae60005481565b6100a3610108366004610171565b600155565b60025461011a9060ff1681565b60405190151581526020016100b8565b6000805460025490919060ff16156101425750429091565b506001549091565b60006020828403121561015b578081fd5b8135801515811461016a578182fd5b9392505050565b600060208284031215610182578081fd5b503591905056fea2646970667358221220194d8b36b8d62d35dcf3470b95d70b4081d32bec89b51cd95fa5f44806aa5d0464736f6c63430008040033";
